import Routes from './routes'
import ReducerFuncs from './store'

const Reducers = (reducerObj) => { reducerObj.digitalDownload = ReducerFuncs }

export {
  Routes,
  Reducers
}
